module.exports = "<div class=form-control> <div id=oneSelect style=display:none></div> <div id=moreSelect style=display:none></div> <div style=display:none id=noneSelect></div> <div id=multi-select></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/multi-select-control/multi-select-control.wx.html
// module id = 1978
// module chunks = 50